import * as React from 'react';
import { useSelector } from 'react-redux';
import { getPorts } from 'src/api/containerTracking';
import SearchTagsInput from 'src/components/common/SearchTagsInput';

const FieldMultiSelectPOL = ({
  value,
  initialValueIds,
  singleMode = false,
  placeholder = 'POL',
  onChange = () => {},
  isWet = false,
  isAir = false,
  isDry = false,
  allowedPortTypes = null,
  onSelectFullPorts = null,
  ...props
}: {
  [key: string]: any;
}) => {
  let timeOutHandler: any;
  const [sourcePortOptions, setSourcePortOptions] = React.useState([] as any[]);
  const fullPortsRef = React.useRef<Record<string, any>>({});
  const plantToLoadingPortsMap = useSelector(
    (state: any) => state.masterData?.plantToLoadingPortsMap
  );
  const [selectedPorts, setSelectedPorts] = React.useState<any[]>([]);
  const [rfqPolWetPorts, setRfqPolWetPorts] = React.useState([]);

  React.useEffect(() => {
    if (initialValueIds) {
      componentDidMount();
    }
  }, []);

  const componentDidMount = async () => {
    await handleOriginPortSearch('');
    const allPorts = await portsFromMap('');
    const ids = (initialValueIds as any[]) || [];
    const preSelectedPorts = allPorts.filter((port: any) =>
      ids.find((id) => id === port.key)
    );
    if (preSelectedPorts?.length) {
      const diffPorts = selectedPorts.filter((sel) => {
        return !preSelectedPorts.find((pre) => {
          return pre.key === sel.key;
        });
      });
      const noChange = !diffPorts && preSelectedPorts.length === selectedPorts.length;
      !noChange && onChange(singleMode ? preSelectedPorts[0] : preSelectedPorts);
      emitFullPorts(singleMode ? preSelectedPorts[0] : preSelectedPorts);
    }
  };

  const getDynamicPorts = async (queryString) => {
    const portType = isDry ? 'DRY' : isWet ? 'WET' : isAir ? 'AIR' : '';
    const response = await getPorts({ queryString, type: allowedPortTypes || portType });
    if (response.isSuccess) {
      return response.data;
    }
    return [];
  };

  const portsFromMap = async (queryString = '') => {
    const res: any[] = [];
    let ports = plantToLoadingPortsMap as any[];
    if (isWet || isAir || isDry || allowedPortTypes?.length) {
      ports = await getDynamicPorts(queryString);
      ports?.map((port) => {
        fullPortsRef.current[port.code] = port;
        res.push({
          key: port.code,
          label: `${port.name} [${port.code}]`,
        });
      });
    } else {
      const keys = Object.keys(ports || {});
      keys?.map((key) =>
        ports[key]?.map((port) =>
          res.push({
            key: port.id,
            label: port.name,
          })
        )
      );
    }
    return res;
  };

  const handleOriginPortSearch = async (queryString: any = '') => {
    // setSourcePortOptions([]);
    if (timeOutHandler) {
      clearTimeout(timeOutHandler);
    }
    timeOutHandler = setTimeout(async () => {
      const newOriginPorts = await portsFromMap(queryString);
      const res: any = newOriginPorts.filter((port) => {
        return port?.label?.toLowerCase().includes(queryString?.toLowerCase());
      });
      setSourcePortOptions(res);
    }, 200);
  };

  const emitFullPorts = (selected) => {
    if (!onSelectFullPorts) {
      return;
    }
    const selectedList = Array.isArray(selected) ? selected : selected ? [selected] : [];
    const fullPorts = selectedList
      .map((item) => fullPortsRef.current[item?.key])
      .filter(Boolean);
    onSelectFullPorts(fullPorts);
  };

  const handleChange = (e) => {
    setSelectedPorts(e);
    onChange(e);
    emitFullPorts(e);
  };

  return (
    <SearchTagsInput
      mode={singleMode ? 'single' : 'multiple'}
      size={'default'}
      placeholder={placeholder}
      thresholdLength={2}
      options={sourcePortOptions}
      searchFunction={handleOriginPortSearch}
      style={{ width: '100%' }}
      value={value || selectedPorts}
      onChange={handleChange}
      {...props}
    />
  );
};

export default React.memo(FieldMultiSelectPOL);
